
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import groupBy from 'lodash/groupBy'

export default {
  directives: {
    TransferDom
  },
  components: {
    Group,
    Cell,
    XHeader,
    Loading
  },
  computed: {
    courseInstances () {
      const keyedHomeworks = groupBy(this.$store.state.todoHomeworks,
       'course_instance_id')
      return this.$store.state.allCourses.map(course => {
        course.homework_count = keyedHomeworks[course.id]
          ? keyedHomeworks[course.id].length
          : 0
        return course
      })
    }
  },
  created () {
    this.$store.dispatch('load', ['allCourses', 'todoHomeworks'])
      .then(() => { this.$vux.loading.hide() })
  },
  async mounted () {
    this.$vux.loading.show()
  }
}



// WEBPACK FOOTER //
// ./src/components/CourseList.vue